import {useTranslation} from "react-i18next";
import {Field, useFormikContext} from "formik";
import PropTypes from "prop-types";

import ToolTip from "../../../utilities/ToolTip";
import useRoutePermissions, {
  UI_PERMISSION_TYPE,
} from "../../adminForms/Ba3aSettings/tabs/PositionsSettings/useRoutePermissions";

const FormikCheckBoxWithLabel = ({
  label,
  labelClassName = "",
  inputClassName = "",
  onCheck = () => {},
  disabled = false,
  name,
  isCheckboxFirst = false,
  children,
  style,
  readOnly,
  tooltipMessage = null,
  bottomTooltip = false,
  noFunctional = false,
  uiPermissionType = UI_PERMISSION_TYPE.WRITABLE,
}) => {
  const {t} = useTranslation();
  const {setFieldValue} = useFormikContext();

  const onCheckBoxCheck = e => {
    onCheck(e);
    setFieldValue(name, e.target.checked);
  };

  const {isDisabledByRoutePermission} = useRoutePermissions({uiPermissionType});

  return (
    <ToolTip
      title={
        noFunctional
          ? t("No functional")
          : isDisabledByRoutePermission && !readOnly && !disabled
          ? "Your position has no permission for this action"
          : typeof tooltipMessage === "string"
          ? t(tooltipMessage)
          : tooltipMessage
      }
      bottom={bottomTooltip}
      className="row aife"
      style={style}
    >
      <>
        {label ? (
          <label className={`row gap5 aistr ${labelClassName}pointer`} style={{display: "flex"}}>
            {!isCheckboxFirst && <div>{t(label)}</div>}

            <Field
              name={name}
              type="checkbox"
              onChange={onCheckBoxCheck}
              className={inputClassName}
              disabled={noFunctional || isDisabledByRoutePermission || disabled || readOnly}
              readOnly={readOnly}
            />
            {isCheckboxFirst && <div>{t(label)}</div>}
          </label>
        ) : (
          <Field
            name={name}
            type="checkbox"
            onChange={onCheckBoxCheck}
            className={inputClassName}
            disabled={noFunctional || isDisabledByRoutePermission || disabled || readOnly}
            readOnly={readOnly}
          />
        )}

        {children}
      </>
    </ToolTip>
  );
};

FormikCheckBoxWithLabel.propTypes = {
  label: PropTypes.string.isRequired,
  labelClassName: PropTypes.string,
  inputClassName: PropTypes.string,
  onCheck: PropTypes.func,
  disabled: PropTypes.bool,
};

export default FormikCheckBoxWithLabel;
